export const data = [{
    path: 'domBrus180',
    name: 'Дом из бруса 180х150(h)',
    description: 'Двухэтажный жилой дом с односкатной кровлей.',
    properties: [
        [
            ['Заголовок', 'Основные характеристики'],
            ['Тип', 'Дом'],
            ['Площадь общая', 153],
            ['Число этажей', 2]
        ],
        [
            ['Заголовок', 'Габариты'],
            ['Ширина', 10],
            ['Длина', 10]
        ],
        [
            ['Заголовок', 'Ссылки'],
            ['Веб диск', 'https://yadi.sk/d/YRaoyD6qekdsP'],
            ['3D модель', 'https://a360.co/2id94QW'],
            ['Видео', 'https://youtu.be/tn25YC4ZEqM'],
        ],
        [
            ['Заголовок', 'Размеры бруса'],
            ['Ширина', 180],
            ['Высота', 150],
            ['Тип', 'Погонажный. Ест. влажности']
        ],
    ],
    images: [
        {
            smile: '/images/domPlosk/smile/1.jpg',
            big: '/images/domPlosk/big/1.jpg'
        },
        {
            smile: '/images/domPlosk/smile/2.jpg',
            big: '/images/domPlosk/big/2.jpg'
        },
        {
            smile: '/images/domPlosk/smile/3.jpg',
            big: '/images/domPlosk/big/3.jpg'
        },
        {
            smile: '/images/domPlosk/smile/4.jpg',
            big: '/images/domPlosk/big/4.jpg'
        }
    ],

},
{
    path: 'kd58',
    name: 'Каркасный дом КД-58',
    description: 'Один из известных проектов от Karkas.info. Был полностью прочерчен в качестве учебного образца. Самый компактный и легкий домик для дачи.',
    properties: [
        [
            ['Заголовок', 'Основные характеристики'],
            ['Тип', 'Дом'],
            ['Площадь общая', 58],
            ['Число этажей', 1.5]
        ],
        [
            ['Заголовок', 'Габариты'],
            ['Ширина', 6],
            ['Длина', 6]
        ],
        [
            ['Заголовок', 'Ссылки'],
            ['Веб диск', 'https://yadi.sk/d/NquauKZu3FXoWt'],
            ['3D модель', 'http://a360.co/2nq8Hnd'],
            ['Оригинал', 'http://www.karkas.info/doma-s-mansardoj/178-proect-i-chertezhi-karkasnogo-doma-kd-58.html'],
        ],
        [
            ['Заголовок', 'Размеры бруса'],
            ['Ширина', 200],
            ['Высота', 50],
            ['Тип', 'Погонажный. Ест. влажности']
        ],
    ],
    images: [
        {
            smile: '/images/kd-58/smile/1.jpg',
            big: '/images/kd-58/big/1.jpg'
        },
        {
            smile: '/images/kd-58/smile/2.jpg',
            big: '/images/kd-58/big/2.jpg'
        },
        {
            smile: '/images/kd-58/smile/3.jpg',
            big: '/images/kd-58/big/3.jpg'
        },
        {
            smile: '/images/kd-58/smile/4.jpg',
            big: '/images/kd-58/big/4.jpg'
        }
    ]
}]
